// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-click-box ion-text {
  user-select: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE/Edge */
}

.right-click-box {
  user-select: none;
  /* Prevent text selection */
  user-select: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE/Edge */
}

ion-list, ion-list.list-ios {
  margin: 0;
  padding: 0;
}

ion-item-divider .title, ion-item ion-label .title {
  border-bottom: 1px solid #8b8b8b;
}

ion-item-divider {
  border: 0;
}

ion-item-divider .title {
  color: #8b8b8b;
}

.title.active {
  background: var(--button-a-background);
  color: var(--button-a-text);
}

ion-item, ion-item-divider {
  background: #fff;
}
ion-item ion-label, ion-item-divider ion-label {
  width: 100%;
  height: 100%;
  margin: 0;
}
ion-item ion-label .title, ion-item-divider ion-label .title {
  padding: 10px 5px;
  font-size: 16px;
}
ion-item ion-label p span, ion-item-divider ion-label p span {
  margin: 0 5px;
}

.step_0 ion-item ion-label .title, .step_0 ion-item-divider ion-label .title {
  padding-right: 5px;
}

.step_1 ion-item ion-label .title, .step_1 ion-item-divider ion-label .title {
  padding-right: 15px;
}

.step_2 ion-item ion-label .title, .step_2 ion-item-divider ion-label .title {
  padding-right: 25px;
}

.step_3 ion-item ion-label .title, .step_3 ion-item-divider ion-label .title {
  padding-right: 35px;
}

.step_4 ion-item ion-label .title, .step_4 ion-item-divider ion-label .title {
  padding-right: 45px;
}

.step_5 ion-item ion-label .title, .step_5 ion-item-divider ion-label .title {
  padding-right: 50px;
}

.viewport {
  height: 100vh; /* full screen height */
  width: 100%;
  overflow-y: auto; /* vertical scroll */
}

.grid-row {
  box-sizing: border-box;
  display: flex;
  justify-content: center; /* centers boxes horizontally */
  gap: 10px; /* optional spacing between boxes */
  flex-wrap: nowrap; /* keep boxes in one row per virtual item */
}

.box {
  height: 170px;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title_height {
  max-height: 65px;
  overflow: hidden;
}

.image-box {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  background: #f7f7f7;
}
.image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-box .placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}
.image-box ion-icon {
  font-size: 40px;
  color: #bbb;
  display: block;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/components/catalog-admin-model/catalog-admin-model.component.scss"],"names":[],"mappings":"AAKA;EACE,iBAAA;EACA,yBAAA,EAAA,WAAA;EACA,qBAAA,EAAA,YAAA;AAJF;;AAOA;EASE,iBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA,EAAA,WAAA;EACA,qBAAA,EAAA,YAAA;AAbF;;AAgBA;EACE,SAAA;EACA,UAAA;AAbF;;AAgBA;EACE,gCAAA;AAbF;;AAgBA;EACE,SAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,sCAAA;EACA,2BAAA;AAbF;;AAgBA;EACE,gBAAA;AAbF;AAgBE;EACE,WAAA;EACA,YAAA;EAYA,SAAA;AAzBJ;AAeI;EAKE,iBAAA;EACA,eAAA;AAjBN;AAwBM;EACE,aAAA;AAtBR;;AA8BI;EACE,kBAAA;AA3BN;;AAmCI;EACE,mBAAA;AAhCN;;AAwCI;EACE,mBAAA;AArCN;;AA8CI;EACE,mBAAA;AA3CN;;AAoDI;EACE,mBAAA;AAjDN;;AA0DI;EACE,mBAAA;AAvDN;;AA8DA;EACE,aAAA,EAAA,uBAAA;EACA,WAAA;EACA,gBAAA,EAAA,oBAAA;AA3DF;;AA8DA;EACE,sBAAA;EACA,aAAA;EACA,uBAAA,EAAA,+BAAA;EACA,SAAA,EAAA,mCAAA;EACA,iBAAA,EAAA,2CAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3DF;;AA8DA;EACE,gBAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA5DF;AA8DE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA5DJ;AA+DE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AA7DJ;AAgEE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AA9DJ","sourcesContent":["ion-icon {\n  //position: absolute;\n  //top: 10px;\n}\n\n.right-click-box ion-text {\n  user-select: none;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE/Edge */\n}\n\n.right-click-box {\n  //width: 200px;\n  //height: 100px;\n  //background: #e0e0e0;\n  //display: flex;\n  //align-items: center;\n  //justify-content: center;\n  //border-radius: 12px;\n  //margin: 40px auto;\n  user-select: none;\n\n  /* Prevent text selection */\n  user-select: none;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE/Edge */\n}\n\nion-list, ion-list.list-ios {\n  margin: 0;\n  padding: 0;\n}\n\nion-item-divider .title, ion-item ion-label .title {\n  border-bottom: 1px solid #8b8b8b;\n}\n\nion-item-divider {\n  border: 0;\n}\n\nion-item-divider .title {\n  color: #8b8b8b;\n}\n\n.title.active {\n  background: var(--button-a-background);\n  color: var(--button-a-text);\n}\n\nion-item, ion-item-divider {\n  background: #fff;\n  //position: relative;\n\n  ion-label {\n    width: 100%;\n    height: 100%;\n\n    .title {\n      //ion-icon{\n      //  height: auto;\n      //}\n\n      padding: 10px 5px;\n      font-size: 16px;\n    }\n\n    //padding: 0 30px;\n    margin: 0;\n\n    p {\n      span {\n        margin: 0 5px;\n      }\n    }\n  }\n}\n\n.step_0 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 5px;\n      //border-color: #0b3e6f;\n    }\n  }\n}\n\n.step_1 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 15px;\n      //border-color: #0b3e6f;\n    }\n  }\n}\n\n.step_2 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 25px;\n      //border-color: #ac1f25;\n    }\n\n  }\n}\n\n.step_3 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 35px;\n      //border-color: #1d4001;\n    }\n\n  }\n}\n\n.step_4 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 45px;\n      //border-color: #7e57ff;\n    }\n\n  }\n}\n\n.step_5 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 50px;\n      //border-color: #322b1d;\n    }\n\n  }\n}\n\n.viewport {\n  height: 100vh; /* full screen height */\n  width: 100%;\n  overflow-y: auto; /* vertical scroll */\n}\n\n.grid-row {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center; /* centers boxes horizontally */\n  gap: 10px; /* optional spacing between boxes */\n  flex-wrap: nowrap; /* keep boxes in one row per virtual item */\n}\n\n.box {\n  height: 170px;\n  width: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.title_height {\n  max-height: 65px;\n  overflow: hidden;\n}\n\n.image-box {\n  width: 50px;\n  height: 50px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f7f7f7;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .placeholder {\n    text-align: center;\n    color: #888;\n    font-size: 14px;\n  }\n\n  ion-icon {\n    font-size: 40px;\n    color: #bbb;\n    display: block;\n    margin-bottom: 4px;\n  }\n}\n\n.subSection {\n  //max-width: 200px;\n}\n.subSection ion-text {\n  //max-height: 44px;\n  //overflow: hidden;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
